import {
  ButtonPrimary, // eslint-disable-line no-unused-vars
  ButtonSecondary, // eslint-disable-line no-unused-vars
  dlsBrightBlue,
  GlyphLeft, // eslint-disable-line no-unused-vars
  Heading, // eslint-disable-line no-unused-vars
} from '@americanexpress/dls-react';
import * as PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { Form } from 'react-final-form';
import { getTrimmedObjectValues, useValidationSchema } from 'axp-fx-common';
import { contactUpdateValidationSchema } from '../../../utils/updateContactValidation';
// eslint-disable-next-line no-unused-vars
import UpdateContactChildForm from './UpdateContactChildForm';
import labels from '../../../constants/labels';

const UpdateContactForm = ({
  selectedContact,
  setStepNo,
  setUpdateContactStepNo,
  setUpdatedContact,
  actionButtonLabelTxt,
  dialCodes,
}) => {
  const handleUpdateContactSubmit = (values) => {
    const updatedContact = getTrimmedObjectValues(values);
    const userNameArr = updatedContact.userFullName.split(' ');
    updatedContact.userFirstName = userNameArr[0];
    updatedContact.userLastName = userNameArr?.length > 1 ? userNameArr[userNameArr.length - 1] : '.';
    setUpdatedContact(updatedContact);
    setUpdateContactStepNo(2);
  };

  const validate = useValidationSchema(contactUpdateValidationSchema);

  return (
    <>
      <div className="flex flex-align-center stack-r margin-2-t">
        <GlyphLeft
          role="button"
          theme={dlsBrightBlue}
          size="lg"
          title="Previous step icon"
          onClick={() => setStepNo(1)}
        />
        <Heading level={2} headingStyle="heading5">
          {`${labels.CONTACT_NM}: ${selectedContact.userFullName}`}
        </Heading>
      </div>
      <Form
        validate={validate}
        onSubmit={(formValues) => handleUpdateContactSubmit(getTrimmedObjectValues(formValues))}
        initialValues={{
          ...selectedContact,
        }}
        render={({ handleSubmit, valid, submitting }) => (
          <form onSubmit={handleSubmit}>
            <div className="flex flex-column margin-4-tb stack">
              <div className="stack">
                <UpdateContactChildForm dialCodes={dialCodes} />
              </div>
              <div className="margin-4-t text-align-right">
                <ButtonSecondary
                  id="cancel-table"
                  className="margin-responsive-r"
                  onClick={() => setStepNo(1)}
                >
                  Cancel
                </ButtonSecondary>
                <ButtonPrimary type="submit" disabled={!valid || submitting}>
                  {actionButtonLabelTxt}
                </ButtonPrimary>
              </div>
            </div>
          </form>
        )}
      />
    </>
  );
};

export default UpdateContactForm;
UpdateContactForm.propTypes = {
  selectedContact: PropTypes.shape({
    userFullName: PropTypes.string.isRequired,
  }).isRequired,
  setStepNo: PropTypes.func.isRequired,
  setUpdateContactStepNo: PropTypes.func.isRequired,
  setUpdatedContact: PropTypes.func.isRequired,
  actionButtonLabelTxt: PropTypes.string.isRequired,
  dialCodes: PropTypes.arrayOf(),
};
